export default (arr: Array<string>, val: string) => {
  const tempIndex = arr.indexOf(val);
  const arrCopy = [...arr];
  // eslint-disable-next-line no-unused-expressions
  tempIndex > -1 ? arrCopy.splice(tempIndex, 1) : arrCopy.push(val);

  return arrCopy;
};
